@if (form) {
  <!-- Address and Area search container-->
  <div lcClass.gt-sm="fx-row fx-gap-sm" lcClass.lt-md="fx-column">
    <!-- Address Search Filter-->
    @if (!isDCApp) {
      <lc-textbox
        class="fx-1-1-0"
        idPrefix="search"
        label="Search by Address"
        placeholder="Search by Address"
        [formControl]="form.searchFormControl"
      />
    }

    <!-- Brand Filter-->
    <lc-multiselect
      class="fx-1-1-0"
      idPrefix="brand"
      label="Brand"
      [displayOptions]="brandDisplayOptions"
      [options]="form.brandOptions"
      [(ngModel)]="form.selectedBrandCodes"
      (openedChange)="onBrandClosed()"
    >
      <ng-template #optionTpl let-item="item">
        <div><span class="status-text option-title">{{item}}</span></div>
      </ng-template>
    </lc-multiselect>

    <!-- Area Filter-->
    <lc-multiselect
      class="fx-1-1-0"
      idPrefix="area"
      label="Area"
      [displayOptions]="areaDisplayOptions"
      [options]="areas"
      [(ngModel)]="form.selectedAreas"
      (openedChange)="onAreaClosed($event)"
    >
      <ng-template #optionTpl let-item="item">
        <div><span class="status-text option-title">{{item}}</span></div>
      </ng-template>
    </lc-multiselect>

    <lc-multiselect
      class="fx-1-1-0"
      displayPath="label"
      idPrefix="status"
      label="Status"
      [displayOptions]="statusDisplayOptions"
      [options]="form.statusOptions"
      [(ngModel)]="form.selectedStatuses"
      (openedChange)="onStatusClosed()"
    >
      <ng-template #optionTpl let-item="item">
        <div>
          <span class="ui-icon ui-icon-status-bullet" [style]="{'background-color': item.color}"></span>
          <span class="status-text option-title">{{item.label}}</span></div>
      </ng-template>
    </lc-multiselect>

    <!-- Date Filter-->
    <lc-multiselect
      #dateSelect
      class="fx-1-1-0"
      displayPath="display"
      dropdownClass="date-filter"
      idPath="text"
      idPrefix="date"
      label="Status Change Date"
      [deselectAllEnabled]="false"
      [displayOptions]="dateDisplayOptions"
      [multiple]="false"
      [options]="form.dateOptions"
      [(ngModel)]="form.selectedDateOption"
    >

      <ng-template #optionTpl let-item="item">
        <div>
          <span class="option-title">{{item.text}}</span>
        </div>

        @if (item.text === 'Custom') {
          <lc-datepicker
            #range
            [defaultEndDate]="item.endDate"
            [defaultStartDate]="item.startDate"
            [enableRangeSelection]="true"
            [maxDate]="maxDate"
            (dateChange)="item.startDate = $event.start; item.endDate = $event.end; dateSelect.updateDisplay(); updateMaxDate($event.start, $event.end);"
          />
        }
      </ng-template>

    </lc-multiselect>
  </div>

  <div lcClass.gt-sm="fx-row fx-gap-sm" lcClass.lt-md="fx-column">
    <div class="fx-row fx-gap-sm fx-1-1-0">
      @if (form.userFilters === 'both') {
        <lc-dropdown
          class="user fx-1-1-0"
          displayPath="viewValue"
          label="Search by User"
          valuePath="value"
          [options]="form.userFilterOptions"
          [(ngModel)]="form.selectedUserFilterOption"
        />
      }

      @if (form.selectedUserFilterOption === 'agent') {
        <lc-agent-search
          class="fx-1-1-0"
          label="Agent"
          placeholder="Search by Agent name"
          [formControl]="form.agentSearch"
          [searchBy]= "form.selectedUserFilterOption"
          [selectedIds]="form.selectedAgentIds"
          (selectedChanged)="onAgentsSelected($event)"
        />
      }

      @if (form.selectedUserFilterOption === 'lcc') {
        <lc-agent-search
          class="fx-1-1-0"
          label="Coordinator"
          placeholder="Search by Coordinator name"
          [formControl]="form.coordinatorSearch"
          [searchBy]= "form.selectedUserFilterOption"
          [selectedIds]="form.selectedCoordinatedIds"
          (selectedChanged)="onCoordinatorsSelected($event)"
        />
      }
    </div>

    @if (form.showAssignment) {
      <lc-multiselect
        class="fx-1-1-0"
        idPrefix="assignment"
        label="Assigned to"
        [displayOptions]="assignmentDisplayOptions"
        [formControl]="form.assignmentsFormControl"
        [options]="form.assignmentOptions"
        (openedChange)="onAssignmentsClosed()"
      />
    }

    @if (form.showFlagged) {
      <lc-multiselect
        class="fx-1-1-0"
        idPrefix="flagged"
        label="Flag"
        [displayOptions]="flagDisplayOptions"
        [formControl]="form.flaggedControl"
        [options]="form.flagOptions"
        (openedChange)="onFlagClosed()"
      />
    }
  </div>
}
